export const PRIMARY = "#0456f5";
export const BLACK = "#3A404B";
export const WHITE = "#FFFFFF";
export const GRAY = "#676464";
